import { render, staticRenderFns } from "./cv5.vue?vue&type=template&id=2cfa631e&scoped=true&"
import script from "./cv5.vue?vue&type=script&lang=js&"
export * from "./cv5.vue?vue&type=script&lang=js&"
import style0 from "./cv5.vue?vue&type=style&index=0&id=2cfa631e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa631e",
  null
  
)

export default component.exports